import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Alert,
  Spinner,
} from '@a-ui/react';

import * as linkActions from '../actions/link';
import * as cardActions from '../actions/card';

const CardLink = () => {
  const { link } = useSelector(state => ({
    link: state.link
  }));
  const [cardLoading, setCardLoading] = useState(false);
  const { card } = useSelector(state => ({
    card: state.card,
  }));
  const toUrl = '/overzicht';

  const history = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(linkActions.linkCard());
  }, []);

  if (link.success) {
    if (!cardLoading) {
      setCardLoading(true);
      dispatch(cardActions.getCard({
        cardNumber: '',
        cardOwnership: 'me',
      }));
    }
  }

  if (card.fetched) {
    history(toUrl);
  }

  return (
    <div className="row ">
      <div className="col-md-6 col-md-offset-3 col-xs-12">
        <div className="box">
          <h5>Sorteerpas linken...</h5>
          <div className="u-margin-top">
            {link.loading && <Spinner size="medium" />}
            {link.error && <div className="u-margin-bottom"><Alert type="danger"><div dangerouslySetInnerHTML={{ __html: link.error }} /></Alert></div>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardLink;
